import React, { useState } from 'react';
import styles from '../../styles/PortalEstudiantesStyles/PortalEstudiantes.module.css';

/**
 * Componente de Horario del Estudiante
 * 
 * ESTADO: Pendiente de implementación
 * TODO: Conectar con la tabla de horarios cuando esté disponible
 * 
 * @param {Object} studentData - Datos del estudiante desde el backend
 */
function Horario({ studentData }) {
  const [selectedPeriod] = useState('Septiembre - Diciembre 2025');

  // TODO: Obtener horarios reales del estudiante desde el backend
  // Por ahora se muestra un mensaje de módulo pendiente
  const horarioData = []; // Se llenará cuando exista la tabla de horarios

  // Configuración de la cuadrícula de horario
  const dias = ['LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES'];
  const horas = [
    '7:00', '8:00', '9:00', '10:00', '11:00', '12:00', 
    '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00'
  ];

  // Si no hay datos de horario, mostrar mensaje de pendiente
  if (!horarioData || horarioData.length === 0) {
    return (
      <div className={styles.horarioContainer}>
        <div className={styles.horarioHeader}>
          <div className={styles.sectionHeader}>
            <span className={styles.sectionIcon}>📅</span>
            <h3 className={styles.sectionTitle}>Horario</h3>
            <span className={styles.pendingBadge}>Pendiente de implementación</span>
          </div>
        </div>
        
        <div className={styles.pendingModuleContainer}>
          <div className={styles.pendingModuleIcon}>📅</div>
          <h4 className={styles.pendingModuleTitle}>Módulo de Horarios</h4>
          <p className={styles.pendingModuleText}>
            El módulo de horarios aún no está implementado. 
            Una vez que se configure la asignación de horarios a estudiantes, 
            aquí se mostrará el horario de clases del periodo actual.
          </p>
          <div className={styles.pendingModuleInfo}>
            <strong>Estudiante:</strong> {studentData?.nombre || 'No disponible'}<br/>
            <strong>Programa:</strong> {studentData?.programa?.nombre || 'No disponible'}<br/>
            <strong>Periodo seleccionado:</strong> {selectedPeriod}
          </div>
        </div>
      </div>
    );
  }

  // Función para obtener la clase en un horario específico
  const getClaseEnHorario = (dia, hora) => {
    for (const materia of horarioData) {
      for (const horario of materia.horarios) {
        if (horario.dia === dia) {
          const horaInicioNum = parseInt(horario.horaInicio.split(':')[0]);
          const horaFinNum = parseInt(horario.horaFin.split(':')[0]);
          const horaActualNum = parseInt(hora.split(':')[0]);
          
          if (horaActualNum >= horaInicioNum && horaActualNum < horaFinNum) {
            return {
              materia: materia.materia,
              salon: horario.salon,
              horaInicio: horario.horaInicio,
              horaFin: horario.horaFin
            };
          }
        }
      }
    }
    return null;
  };

  return (
    <div className={styles.horarioContainer}>
      <div className={styles.horarioHeader}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionIcon}>📅</span>
          <h3 className={styles.sectionTitle}>Periodo 6 ({selectedPeriod})</h3>
        </div>
      </div>

      <div className={styles.scheduleGrid}>
        {/* Encabezado de días */}
        <div className={styles.scheduleHeader}>
          <div className={styles.timeColumn}>HORA</div>
          {dias.map(dia => (
            <div key={dia} className={styles.dayColumn}>
              {dia}
            </div>
          ))}
        </div>

        {/* Filas de horario */}
        <div className={styles.scheduleBody}>
          {horas.map((hora) => (
            <div key={hora} className={styles.scheduleRow}>
              <div className={styles.timeCell}>{hora}</div>
              {dias.map(dia => {
                const clase = getClaseEnHorario(dia, hora);
                return (
                  <div key={`${dia}-${hora}`} className={styles.scheduleCell}>
                    {clase && (
                      <div className={styles.classBlock}>
                        <div className={styles.className}>{clase.materia}</div>
                        <div className={styles.classDetails}>
                          {clase.salon}
                        </div>
                        <div className={styles.classTime}>
                          {clase.horaInicio} - {clase.horaFin}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      {/* Leyenda */}
      <div className={styles.scheduleLegend}>
        <span className={styles.legendTitle}>Materias del periodo:</span>
        {horarioData.map((materia, index) => (
          <div key={index} className={styles.legendItem}>
            <div className={styles.legendColor} style={{ backgroundColor: `hsl(${index * 60}, 60%, 50%)` }} />
            <span>{materia.materia}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Horario;
